import type { Theme, SxProps } from '@mui/material/styles';

import { Box, Tooltip, Skeleton, Typography } from '@mui/material';

import { StyledTooltipLabel } from '../styles/sharedStyles';

type InfoBoxProps = {
  label: string;
  value: number | string;
  testIdLabel: string;
  testIdValue: string;
  testId?: string;
  tooltip?: string;
  loading?: boolean;
  sx?: SxProps<Theme>;
};

export function InfoBox({
  label,
  value,
  testIdLabel,
  testIdValue,
  testId,
  tooltip,
  loading = false,
  sx,
}: InfoBoxProps) {
  return (
    <Box
      data-testid={testId}
      sx={[
        {
          display: 'flex',
          flexDirection: 'column',
          // Preserve spacing for existing callers; future cleanup should move it to parent layouts.
          mt: 3,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {tooltip ? (
        <Box sx={{ alignSelf: 'flex-start' }}>
          <Tooltip arrow title={tooltip} placement="top">
            <StyledTooltipLabel data-testid={testIdLabel}>
              <Typography component="span" sx={{ typography: 'body2' }}>
                {label}
              </Typography>
            </StyledTooltipLabel>
          </Tooltip>
        </Box>
      ) : (
        <Typography
          component="span"
          sx={{ typography: 'body2', color: 'text.secondary' }}
          data-testid={testIdLabel}
        >
          {label}
        </Typography>
      )}
      {loading ? (
        <Skeleton
          variant="text"
          sx={{ width: '60%', minHeight: '1.5rem' }}
          data-testid={`${testIdValue}-skeleton`}
        />
      ) : (
        <Typography
          component="span"
          sx={{ typography: 'subtitle2', color: 'text.primary', minHeight: '1.5rem' }}
          data-testid={testIdValue}
        >
          {value || '\u00A0'}
        </Typography>
      )}
    </Box>
  );
}
